import axios from "api/axios";

export const createFavoriteTemplate = async (data) => {
  const response = await axios.post('/api/favorite', data);
  return response.data;
}

export const getAllFavoriteTemplates = async () => {
  const response = await axios.get('/api/favorite');
  return response.data;
}

export const deleteFavoriteTemplate = async ({ templateId }) => {
  const response = await axios.delete(`/api/favorite/${templateId}`);
  return response.data;
}